export const educationMessages = {
  employees: `All employee costs have an additional overhead cost included in your bid.`,
  floors: `Hard floor surfaces need sweeping and mopping, which means they take a little longer to clean.`,
  frequency: `A recommended frequency to maintain cleanliness for the space is included in pricing by square feet.`,
  expectations: `Understanding the client's expectations are THE key to your success with their account, and this bid. This can impact the time it takes to clean the account and meet those expectations.`,
  location: `Healthcare facilities require more attention to detail and this has been factored into your bid.`,
  place: `We used your state's average price per square foot while calculating your bid.`
}
